module.exports = __webpack_public_path__ + "img/Airbnb-Office-Everyday-Stretches-Neck.3c3a59d5.jpg";